import { ELinks } from '@sharedInterfaces/globalEnums';
import { EIconCategory } from '@src/helper/iconRegistry';
import type Employee from '@src/Objects/Employee';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import FeatureCardWidget from './FeatureCardWidget';

interface CertificatesCardWidgetProps {
    employee: Employee;
    onTabChange: (tabIndex: number) => void;
}

function CertificatesCardWidget({ employee, onTabChange }: CertificatesCardWidgetProps) {
    const navigate = useNavigate();

    return (
        <FeatureCardWidget
            title="Zertifikate"
            description="Verwalte deine beruflichen Zertifizierungen und Qualifikationen. Lade neue Zertifikate hoch und behalte den Überblick über Ablaufdaten."
            imagePath="/img/t4lo_zertifikate.png"
            iconCategory={EIconCategory.CERTIFICATES}
            onClick={() => onTabChange(3)}
        />
    );
}

export default CertificatesCardWidget;
